<template>
  <section id="userIndex">
    <QuestionForm
      v-if="formDialog"
      :dialogProp="formDialog"
      @dialog:close="closeDialog"
      :dataToForm="dataToForm"
      :mode="formMode"
      :category_id="id"
    />
    <DeleteQuestion
      :dialogProp="deleteDialog"
      @dialog:close="closeDialog"
      :item="itemToDelete"
    />
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="2" md="auto">
          <v-row>
            <v-col cols="auto">
              <v-btn
                @click="backAction"
                rounded
                class="white rounded-xl"
                small
                min-width="0"
                :dark="isDark"
              >
                <v-icon small>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="10" md="auto">
          <h2
            :class="[
              isMobile ? 'h5' : 'h4',
              isMobile && isDark ? 'white--text' : 'primary--text',
            ]"
            style="word-break: normal"
          >
            {{ Category.title }}
          </h2>
        </v-col>
      </v-row>
      <v-row class="justify-between align-center">
        <v-col cols="12" md="auto">
          <v-btn
            class="accent shadow-4 px-8"
            large
            rounded
            @click.stop="openRegisterForm()"
            >Añadir Pregunta</v-btn
          >
        </v-col>

        <v-col cols="12" md="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :items-per-page="itemsPerPage"
        hide-default-footer
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.answers`]="{ item }">
          <v-list-item-content class="d-none d-md-block ml-3">
            <v-btn
              class="shadow-4 px-8"
              rounded
              @click.stop="toggleAnswers(item.id)"
              >Ver Respuestas</v-btn
            >
          </v-list-item-content>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="editQuestion(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteQuestion(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>
    <!-- PAGINATION -->
    <v-row justify="end">
      <v-col cols="auto">
        <v-pagination
          circle
          color="primary"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
    </v-row>

    <Answers
      v-if="answersDialog"
      :idQuestion="idQuestionSelected"
      :answersDialog="answersDialog"
      @dialog:close="toggleAnswers"
    />
  </section>
</template>

<script>
import QuestionForm from "@/components/Questions/QuestionForm";
import DeleteQuestion from "@/components/Questions/DeleteQuestion";
import Answers from "@/components/Answers";

export default {
  components: {
    DeleteQuestion,
    QuestionForm,
    Answers,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Titulo",
          align: "left",
          sortable: true,
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Respuestas Asociadas",
          align: "left",
          sortable: false,
          value: "answers",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      answersTableHeaders: [
        {
          text: "Titulo",
          align: "left",
          sortable: true,
          value: "title",
          class: "primary--text",
          width: "50%",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "value",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Acciones",
          align: "left",
          sortable: true,
          value: "actions",
          class: "primary--text",
          width: "25%",
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      data: [],
      // Form
      formDialog: false,
      formMode: "register",
      dataToForm: null,

      //Delete Dialog
      deleteDialog: false,
      itemToDelete: null,

      //Answers
      idQuestionSelected: null,
      answersDialog: false,
    };
  },
  created() {
    if (!this.Category) this.getCategories();
    if (
      this.Questions.length <= 0 ||
      this.Questions.some((q) => q.category_id !== Number(this.id))
    )
      this.GetQuestions();
    else this.data = this.Questions;
  },

  computed: {
    Questions() {
      return this.$store.getters["questions/GET_ALL_QUESTIONS"];
    },
    Category() {
      return this.$store.getters["categories/GET_CATEGORY"](Number(this.id));
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  methods: {
    toggleAnswers(id) {
      if (!this.answersDialog) this.idQuestionSelected = id;
      this.answersDialog = !this.answersDialog;
    },
    openRegisterForm() {
      this.formDialog = true;
      this.formMode = "register";
    },
    closeDialog() {
      this.formDialog = false;
      this.deleteDialog = false;
      this.itemToDelete = false;
      this.dataToForm = null;
    },
    editQuestion(item) {
      this.formDialog = true;
      this.formMode = "edit";
      this.dataToForm = item;
    },
    deleteQuestion(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    // Store
    async GetQuestions() {
      try {
        const response = await this.$store.dispatch(
          "questions/SHOW_QUESTIONS",
          this.id || this.$route.params.id
        );
        this.data = this.Questions;
      } catch (error) {
        console.log(error);
      }
    },
    async getCategories() {
      await this.$store.dispatch("categories/SHOW_CATEGORIES");
      return;
    },
    backAction() {
      this.$router.push(`/categories`);
    },

    /*
        dateFormat(date) {
            const dateFormatted = date
                .toString()
                .slice(0, 10)
                .split("-")
                .reverse()
                .join("/");
            return dateFormatted;
        },

        
        ShowUsers(users) {
            console.log(users);
            this.dialog = true;
            this.UserInfo = users.user_relation;
            console.log(this.UserInfo);
        },
        editClient(client) {
            // this.clientInfo = client;
            this.clientInfo = {
                id: client.id,
                name: client.name,
                user: client.user,
                email: client.email,
                ip: client.ip,
                nameBd: client.nameBd,
                port: client.port,
                ip_sokect: client.ip_sokect,
                user_sokect: client.user_sokect,
                clave_sokect: client.clave_sokect,
                port_sokect: client.port_sokect
            };
            this.updateActive = true;
            console.log(this.clientInfo);
        },
        async deleteClient(client) {
            this.clientInfo = client;
            const response = await this.$store.dispatch(
                "clients/DELETE_CLIENTS",
                {
                    id: client.id
                }
            );
            this.errorData = response.data;
            this.activeAlert = true;
            this.colorAlert = "blue";
            console.log(response);
        },
        eventdialog(message) {
            this.updateActive = false;
            if (message !== "cerrar") {
                this.errorData = "Cliente Actualizado";
                this.activeAlert = true;
                this.colorAlert = "blue";
            }
        },
        closeAlert() {
            this.activeAlert = false;
        },
        async changeStatus(value) {
            console.log("Prueba", value);
            const conf = confirm("CAMBIAR ESTATUS");
            if (conf) {
                const response = await this.$store.dispatch(
                    "clients/CHANGE_STATUS",
                    {
                        id: value.id
                    }
                );
            }
        }*/
  },
};
</script>
